/* eslint-disable spire/export-styles */
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer from "@insite/mobius/GridContainer";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    depth = "depth",
    nodeId = "nodeId",
    leftMargin = "leftMargin",
    marginBottom = "marginBottom",
    marginBetweenButtons = "marginBetweenButtons"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.depth]: number;
        [fields.nodeId]: LinkFieldValue;
        [fields.leftMargin]: number;
        [fields.marginBottom]: number;
        [fields.marginBetweenButtons]: number;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    rootPageLink: getPageLinkByNodeId(state, ownProps.fields.nodeId?.value || getCurrentPage(state).nodeId),
    pageId: getCurrentPage(state).nodeId,
    displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
    isPricingHiddenByRole: Boolean(getSettingsCollection(state).productSettings.isPricingHiddenByRole),
});


const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const OrderHistoryTabs = (props: Props) => {

    if (!props.rootPageLink || !props.rootPageLink.children) {
        return null;
    }

    const renderLinks = (pageLinks: PageLinkModel[], currentDepth: number) => {
        if (currentDepth > props.fields.depth) {
            return;
        }

        const nextDepth = currentDepth + 1;

        const navigateUrl = (title: string) => {
            window.location.href = title!;
        };

        if(props.isPricingHiddenByRole)
        {
            return pageLinks
            .filter(pageLink => {
                return (
                    pageLink.title === "Order History"
                    || pageLink.title === "Saved Orders"
                );
            })
            .map(pageLink => {
                return (
                    <Button variant={props.pageId === pageLink.id ? 'tertiary' : 'primary'} buttonType="solid"
                    onClick={() => navigateUrl(pageLink.url)}
                    css={css `margin-right: ${props.fields.marginBetweenButtons}px`}>
                        {pageLink.title}
                    </Button>
                );
            });
        }

        return pageLinks
        .filter(pageLink => {
            return (
                pageLink.title === "Order History"
                || pageLink.title === "Saved Orders"
                || pageLink.title === "Invoices"
                || pageLink.title === "RMA History"
            );
        })
        .map(pageLink => {
            return (
                <Button variant={props.pageId === pageLink.id ? 'tertiary' : 'primary'} buttonType="solid"
                onClick={() => navigateUrl(pageLink.url)}
                css={css `margin-right: ${props.fields.marginBetweenButtons}px`}>
                    {pageLink.title}
                </Button>
            );
        });
    };

    return (
        <GridContainer css={css `margin-bottom: ${props.fields.marginBottom}px; margin-left: ${props.fields.leftMargin}px`}>
            {renderLinks(props.rootPageLink.children, 1)}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistoryTabs),
    definition: {
        group: "Basic",
        icon: "OrderHistoryTabs",
        fieldDefinitions: [
            {
                name: fields.depth,
                displayName: "Depth",
                editorTemplate: "IntegerField",
                defaultValue: 2,
                fieldType: "General",
            },
            {
                name: fields.nodeId,
                displayName: "Page",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                allowUrls: item => false,
                allowCategories: item => false,
            },
            {
                name: fields.leftMargin,
                displayName: "Left Margin",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
            },
            {
                name: fields.marginBottom,
                displayName: "Margin Bottom",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
            },
            {
                name: fields.marginBetweenButtons,
                displayName: "Margin Between Buttons",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                max: 100,
                min: 0,
            },
        ],
    },
};

export default widgetModule;
